import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper'
import TypeConverter from '@/Utility/TypeConverter';
import KendoDatePickerViewModel from '@/Components/KendoDateTimePicker/ViewModels/KendoDatePickerViewModel';
import KendoDatePicker from '@/Components/KendoDateTimePicker/Controls/KendoDatePicker';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import { FilterInfo } from '#/DefaultViewExtensionInterfaces';

export default class KendoDatePickerFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private KendoDatePickerViewModel = ComponentManager.getViewModel<typeof KendoDatePickerViewModel>('KendoDatePickerViewModel');
    private KendoDatePicker = ComponentManager.getControl<typeof KendoDatePicker>('KendoDatePicker');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: KendoDatePickerViewModel;

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: KendoDatePicker;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = this.detailViewItem.viewModel || new this.KendoDatePickerViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getComputed(this.detailViewItem.name, {
                read: (observable: any) => {
                    let value = observable();

                    if (value != null && this.isEnabled() === true) {
                        value = value.substr(0, 10) + 'T00:00:00';
                        //observable(value);
                    }

                    return value;
                },
                write: (observable: any, value: any) => {
                    observable(value);
                }
            }),
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            })
        });

        this.control = new this.KendoDatePicker(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);

        this.registerDefaultValidation([this.detailViewItem.name]);
        this.registerCustomValidation([this.detailViewItem.name], this.viewModel.rawValue, (rawValue: string): boolean => {
            let isNullableType = TypeConverter.typeIsNullable(this.detailViewItem.dotNetTypeName) || this.detailViewItem.useInFilter;

            return this.viewModel.customValidate(rawValue, isNullableType);
        });

        return this.jQueryControl;
    }

    public getValueForFilter(): Object {
        let ret = {};
        ret[this.detailViewItem.name] = this.context.genericObject.getValue(this.detailViewItem.name);

        return ret;
    }

    public getFilterInfo(): FilterInfo {
        return {
            field: this.detailViewItem.name,
            value: DateHelper.toDotNetDateTimeString(this.viewModel?.date()) || ''
        }
    }
}

ComponentManager.setFactory('KendoDatePicker', KendoDatePickerFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');